import { render, staticRenderFns } from "./CommonSense.vue?vue&type=template&id=6100ee52&scoped=true&"
import script from "./CommonSense.vue?vue&type=script&lang=js&"
export * from "./CommonSense.vue?vue&type=script&lang=js&"
import style0 from "./CommonSense.vue?vue&type=style&index=0&id=6100ee52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6100ee52",
  null
  
)

export default component.exports